import { render, staticRenderFns } from "./windowslive.button.vue?vue&type=template&id=099cd60b&"
import script from "./windowslive.button.vue?vue&type=script&lang=ts&"
export * from "./windowslive.button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports